import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * Caches routes that have `data: { reuse: true }` so they survive navigation
 * and are restored (not re-created) when the user navigates back.
 */
export class CachedRouteReuseStrategy implements RouteReuseStrategy {
	private cache = new Map<string, DetachedRouteHandle>();

	shouldDetach(route: ActivatedRouteSnapshot): boolean {
		return route.data['reuse'] === true;
	}

	store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
		const key = this.getKey(route);
		if (!key) return;

		if (handle) {
			this.cache.set(key, handle);
		} else {
			this.cache.delete(key);
		}
	}

	shouldAttach(route: ActivatedRouteSnapshot): boolean {
		const key = this.getKey(route);
		return !!key && this.cache.has(key);
	}

	retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
		const key = this.getKey(route);
		return key ? (this.cache.get(key) ?? null) : null;
	}

	shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
		return future.routeConfig === curr.routeConfig;
	}

	private getKey(route: ActivatedRouteSnapshot): string | null {
		return route.routeConfig?.path ?? null;
	}
}
